export const DEFAULT_ACTION = "app/EmploymentMasterPage/DEFAULT_ACTION";
export const UPDATE_EMPLOYEE ="app/EmploymentMasterPage/UPDATE_EMPLOYEE";
export const UPDATE_EMPLOYEE_IDS ="app/EmploymentMasterPage/UPDATE_EMPLOYEE_IDS"